import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { getOwner } from "@ember/application";
import { Input, setComponentTemplate } from "@ember/component";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { htmlSafe } from "@ember/template";
import { Promise } from "rsvp";
import ConditionalLoadingSection from "discourse/components/conditional-loading-section";
import DButton from "discourse/components/d-button";
import DModal from "discourse/components/d-modal";
import RadioButton from "discourse/components/radio-button";
import { categoryBadgeHTML } from "discourse/helpers/category-link";
import { topicLevels } from "discourse/lib/notification-levels";
import Category from "discourse/models/category";
import Topic from "discourse/models/topic";
import autoFocus from "discourse/modifiers/auto-focus";
import i18n from "discourse-common/helpers/i18n";
import CategoryChooser from "select-kit/components/category-chooser";
import TagChooser from "select-kit/components/tag-chooser";
import { createTemplateFactory } from "@ember/template-factory";
const _customActions = {};
export function addBulkDropdownAction(name1, customAction1) {
  _customActions[name1] = customAction1;
}
export default class BulkTopicActions extends Component {
  static #_ = (() => dt7948.g(this.prototype, "router", [service]))();
  #router = (() => (dt7948.i(this, "router"), void 0))();
  static #_2 = (() => dt7948.g(this.prototype, "toasts", [service]))();
  #toasts = (() => (dt7948.i(this, "toasts"), void 0))();
  static #_3 = (() => dt7948.g(this.prototype, "activeComponent", [tracked], function () {
    return null;
  }))();
  #activeComponent = (() => (dt7948.i(this, "activeComponent"), void 0))();
  static #_4 = (() => dt7948.g(this.prototype, "tags", [tracked], function () {
    return [];
  }))();
  #tags = (() => (dt7948.i(this, "tags"), void 0))();
  static #_5 = (() => dt7948.g(this.prototype, "categoryId", [tracked]))();
  #categoryId = (() => (dt7948.i(this, "categoryId"), void 0))();
  static #_6 = (() => dt7948.g(this.prototype, "loading", [tracked]))();
  #loading = (() => (dt7948.i(this, "loading"), void 0))();
  static #_7 = (() => dt7948.g(this.prototype, "errors", [tracked]))();
  #errors = (() => (dt7948.i(this, "errors"), void 0))();
  static #_8 = (() => dt7948.g(this.prototype, "isSilent", [tracked], function () {
    return false;
  }))();
  #isSilent = (() => (dt7948.i(this, "isSilent"), void 0))();
  static #_9 = (() => dt7948.g(this.prototype, "closeNote", [tracked], function () {
    return null;
  }))();
  #closeNote = (() => (dt7948.i(this, "closeNote"), void 0))();
  notificationLevelId = null;
  constructor() {
    super(...arguments);
    if (this.model.initialAction === "set-component") {
      if (this.model.initialActionLabel in _customActions) {
        _customActions[this.model.initialActionLabel]({
          setComponent: this.setComponent.bind(this)
        });
      }
    }
  }
  async perform(operation1) {
    if (this.model.bulkSelectHelper.selected.length > 20) {
      this.showProgress = true;
    }
    try {
      return await this._processChunks(operation1);
    } catch {
      this.errors = true;
      this.showToast();
    } finally {
      this.processedTopicCount = 0;
      this.showProgress = false;
    }
  }
  _generateTopicChunks(allTopics1) {
    let startIndex1 = 0;
    const chunkSize1 = 30;
    const chunks1 = [];
    while (startIndex1 < allTopics1.length) {
      chunks1.push(allTopics1.slice(startIndex1, startIndex1 + chunkSize1));
      startIndex1 += chunkSize1;
    }
    return chunks1;
  }
  _processChunks(operation1) {
    const allTopics1 = this.model.bulkSelectHelper.selected;
    const topicChunks1 = this._generateTopicChunks(allTopics1);
    const topicIds1 = [];
    const options1 = {};
    if (this.isSilent) {
      const newType1 = operation1.type === "close" ? "silent_close" : operation1.type;
      operation1.type = newType1;
    }
    if (this.isCloseAction && this.closeNote) {
      operation1["message"] = this.closeNote;
    }
    const tasks1 = topicChunks1.map(topics1 => async () => {
      const result1 = await Topic.bulkOperation(topics1, operation1, options1);
      this.processedTopicCount += topics1.length;
      return result1;
    });
    return new Promise((resolve1, reject1) => {
      const resolveNextTask1 = async () => {
        if (tasks1.length === 0) {
          const topics1 = topicIds1.map(id1 => allTopics1.findBy("id", id1));
          return resolve1(topics1);
        }
        const task1 = tasks1.shift();
        try {
          const result1 = await task1();
          if (result1?.topic_ids) {
            topicIds1.push(...result1.topic_ids);
          }
          resolveNextTask1();
        } catch {
          reject1();
        }
      };
      resolveNextTask1();
    });
  }
  setComponent(component1) {
    this.activeComponent = component1;
  }
  static #_10 = (() => dt7948.n(this.prototype, "setComponent", [action]))();
  registerCustomAction(customAction1) {
    this.customAction = customAction1;
  }
  static #_11 = (() => dt7948.n(this.prototype, "registerCustomAction", [action]))();
  performAction() {
    this.loading = true;
    switch (this.model.action) {
      case "close":
        this.forEachPerformed({
          type: "close"
        }, t1 => t1.set("closed", true));
        break;
      case "archive":
        this.forEachPerformed({
          type: "archive"
        }, t1 => t1.set("archived", true));
        break;
      case "archive_messages":
      case "move_messages_to_inbox":
        let userPrivateMessages1 = getOwner(this).lookup("controller:user-private-messages");
        let params1 = {
          type: this.model.action
        };
        if (userPrivateMessages1.isGroup) {
          params1.group = userPrivateMessages1.groupFilter;
        }
        this.performAndRefresh(params1);
        break;
      case "unlist":
        this.forEachPerformed({
          type: "unlist"
        }, t1 => t1.set("unlisted", true));
        break;
      case "relist":
        this.forEachPerformed({
          type: "relist"
        }, t1 => t1.set("unlisted", false));
        break;
      case "append-tags":
        this.performAndRefresh({
          type: "append_tags",
          tags: this.tags
        });
        break;
      case "replace-tags":
        this.performAndRefresh({
          type: "change_tags",
          tags: this.tags
        });
        break;
      case "remove-tags":
        this.performAndRefresh({
          type: "remove_tags"
        });
        break;
      case "delete":
        this.performAndRefresh({
          type: "delete"
        });
        break;
      case "reset-bump-dates":
        this.performAndRefresh({
          type: "reset_bump_dates"
        });
        break;
      case "defer":
        this.performAndRefresh({
          type: "destroy_post_timing"
        });
        break;
      case "update-notifications":
        this.performAndRefresh({
          type: "change_notification_level",
          notification_level_id: this.notificationLevelId
        });
        break;
      case "update-category":
        this.forEachPerformed({
          type: "change_category",
          category_id: this.categoryId
        }, t1 => t1.set("category_id", this.categoryId));
        break;
      default:
        // Plugins can register their own custom actions via onRegisterAction
        // when the activeComponent is rendered.
        if (this.customAction) {
          this.customAction(this.performAndRefresh.bind(this));
        } else {
          _customActions[this.model.initialActionLabel](this);
        }
    }
  }
  static #_12 = (() => dt7948.n(this.prototype, "performAction", [action]))();
  showToast() {
    this.loading = false;
    if (this.errors) {
      this.toasts.error({
        duration: 3000,
        data: {
          message: i18n("generic_error")
        }
      });
    } else {
      this.toasts.success({
        duration: 3000,
        data: {
          message: i18n("topics.bulk.completed")
        }
      });
    }
  }
  async forEachPerformed(operation1, cb1) {
    const topics1 = await this.perform(operation1);
    if (topics1) {
      topics1.forEach(cb1);
      this.model.refreshClosure?.();
      this.args.closeModal();
      this.model.bulkSelectHelper.toggleBulkSelect();
      this.showToast();
    }
  }
  static #_13 = (() => dt7948.n(this.prototype, "forEachPerformed", [action]))();
  async performAndRefresh(operation1) {
    await this.perform(operation1);
    this.model.refreshClosure?.().then(() => {
      this.args.closeModal();
      this.model.bulkSelectHelper.toggleBulkSelect();
      this.showToast();
    });
  }
  static #_14 = (() => dt7948.n(this.prototype, "performAndRefresh", [action]))();
  get isTagAction() {
    return this.model.action === "append-tags" || this.model.action === "replace-tags";
  }
  get isNotificationAction() {
    return this.model.action === "update-notifications";
  }
  get isCategoryAction() {
    return this.model.action === "update-category";
  }
  get isCloseAction() {
    return this.model.action === "close";
  }
  updateCloseNote(event1) {
    event1.preventDefault();
    this.closeNote = event1.target.value;
  }
  static #_15 = (() => dt7948.n(this.prototype, "updateCloseNote", [action]))();
  get model() {
    return this.args.model;
  }
  get notificationLevels() {
    return topicLevels.map(level1 => ({
      id: level1.id.toString(),
      name: i18n(`topic.notifications.${level1.key}.title`),
      description: i18n(`topic.notifications.${level1.key}.description`)
    }));
  }
  get soleCategoryId() {
    if (this.model.bulkSelectHelper.selectedCategoryIds.length === 1) {
      return this.model.bulkSelectHelper.selectedCategoryIds[0];
    }
    return null;
  }
  get soleCategory() {
    if (!this.soleCategoryId) {
      return null;
    }
    return Category.findById(this.soleCategoryId);
  }
  get soleCategoryBadgeHTML() {
    return categoryBadgeHTML(this.soleCategory, {
      allowUncategorized: true
    });
  }
  get showSoleCategoryTip() {
    return this.soleCategory && this.isTagAction;
  }
  onCategoryChange(categoryId1) {
    this.categoryId = categoryId1;
  }
  static #_16 = (() => dt7948.n(this.prototype, "onCategoryChange", [action]))();
  static #_17 = (() => setComponentTemplate(createTemplateFactory(
  /*
    
      <DModal
        @title={{@model.title}}
        @subtitle={{@model.description}}
        @closeModal={{@closeModal}}
        class="topic-bulk-actions-modal -large"
      >
        <:body>
          <ConditionalLoadingSection
            @isLoading={{this.loading}}
            @title={{i18n "topics.bulk.performing"}}
          >
            <div class="topic-bulk-actions-modal__selection-info">
  
              {{#if this.showSoleCategoryTip}}
                {{htmlSafe
                  (i18n
                    "topics.bulk.selected_sole_category"
                    count=@model.bulkSelectHelper.selected.length
                  )
                }}
                {{htmlSafe this.soleCategoryBadgeHTML}}
              {{else}}
                {{htmlSafe
                  (i18n
                    "topics.bulk.selected"
                    count=@model.bulkSelectHelper.selected.length
                  )
                }}
  
              {{/if}}
            </div>
  
            {{#if this.isCategoryAction}}
              <p>
                <CategoryChooser
                  @value={{this.categoryId}}
                  @onChange={{this.onCategoryChange}}
                />
              </p>
            {{/if}}
  
            {{#if this.isNotificationAction}}
              <div class="bulk-notification-list">
                {{#each this.notificationLevels as |level|}}
                  <div class="controls">
                    <label class="radio notification-level-radio checkbox-label">
                      <RadioButton
                        @value={{level.id}}
                        @name="notification_level"
                        @selection={{this.notificationLevelId}}
                      />
                      <strong>{{level.name}}</strong>
                      <div class="description">{{htmlSafe
                          level.description
                        }}</div>
                    </label>
                  </div>
                {{/each}}
              </div>
            {{/if}}
  
            {{#if this.isTagAction}}
              <p><TagChooser
                  @tags={{this.tags}}
                  @categoryId={{this.soleCategoryId}}
                /></p>
            {{/if}}
  
            {{#if this.activeComponent}}
              {{component
                this.activeComponent
                onRegisterAction=this.registerCustomAction
              }}
            {{/if}}
  
            {{#if this.isCloseAction}}
              <div class="bulk-close-note-section">
                <label>
                  {{i18n "topic_bulk_actions.close_topics.note"}}&nbsp;<span
                    class="label-optional"
                  >{{i18n "topic_bulk_actions.close_topics.optional"}}</span>
                </label>
  
                <textarea
                  id="bulk-close-note"
                  {{on "input" this.updateCloseNote}}
                  {{autoFocus}}
                >{{this.closeNote}}</textarea>
              </div>
            {{/if}}
          </ConditionalLoadingSection>
        </:body>
  
        <:footer>
          {{#if @model.allowSilent}}
            <div class="topic-bulk-actions-options">
              <label
                for="topic-bulk-action-options__silent"
                class="checkbox-label"
              >
                <Input
                  id="topic-bulk-action-options__silent"
                  @type="checkbox"
                  @checked={{this.isSilent}}
                />{{i18n "topics.bulk.silent"}}</label>
            </div>
          {{/if}}
  
          <DButton
            @action={{@closeModal}}
            @label="cancel"
            class="btn-transparent d-modal-cancel"
            id="bulk-topics-cancel"
          />
          <DButton
            @action={{this.performAction}}
            @disabled={{this.loading}}
            @icon="check"
            @label="topics.bulk.confirm"
            id="bulk-topics-confirm"
            class="btn-primary"
          />
        </:footer>
  
      </DModal>
    
  */
  {
    "id": "W3G6Lkiq",
    "block": "[[[1,\"\\n    \"],[8,[32,0],[[24,0,\"topic-bulk-actions-modal -large\"]],[[\"@title\",\"@subtitle\",\"@closeModal\"],[[30,1,[\"title\"]],[30,1,[\"description\"]],[30,2]]],[[\"body\",\"footer\"],[[[[1,\"\\n        \"],[8,[32,1],null,[[\"@isLoading\",\"@title\"],[[30,0,[\"loading\"]],[28,[32,2],[\"topics.bulk.performing\"],null]]],[[\"default\"],[[[[1,\"\\n          \"],[10,0],[14,0,\"topic-bulk-actions-modal__selection-info\"],[12],[1,\"\\n\\n\"],[41,[30,0,[\"showSoleCategoryTip\"]],[[[1,\"              \"],[1,[28,[32,3],[[28,[32,2],[\"topics.bulk.selected_sole_category\"],[[\"count\"],[[30,1,[\"bulkSelectHelper\",\"selected\",\"length\"]]]]]],null]],[1,\"\\n              \"],[1,[28,[32,3],[[30,0,[\"soleCategoryBadgeHTML\"]]],null]],[1,\"\\n\"]],[]],[[[1,\"              \"],[1,[28,[32,3],[[28,[32,2],[\"topics.bulk.selected\"],[[\"count\"],[[30,1,[\"bulkSelectHelper\",\"selected\",\"length\"]]]]]],null]],[1,\"\\n\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"isCategoryAction\"]],[[[1,\"            \"],[10,2],[12],[1,\"\\n              \"],[8,[32,4],null,[[\"@value\",\"@onChange\"],[[30,0,[\"categoryId\"]],[30,0,[\"onCategoryChange\"]]]],null],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"isNotificationAction\"]],[[[1,\"            \"],[10,0],[14,0,\"bulk-notification-list\"],[12],[1,\"\\n\"],[42,[28,[31,2],[[28,[31,2],[[30,0,[\"notificationLevels\"]]],null]],null],null,[[[1,\"                \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n                  \"],[10,\"label\"],[14,0,\"radio notification-level-radio checkbox-label\"],[12],[1,\"\\n                    \"],[8,[32,5],null,[[\"@value\",\"@name\",\"@selection\"],[[30,3,[\"id\"]],\"notification_level\",[30,0,[\"notificationLevelId\"]]]],null],[1,\"\\n                    \"],[10,\"strong\"],[12],[1,[30,3,[\"name\"]]],[13],[1,\"\\n                    \"],[10,0],[14,0,\"description\"],[12],[1,[28,[32,3],[[30,3,[\"description\"]]],null]],[13],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n\"]],[3]],null],[1,\"            \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"isTagAction\"]],[[[1,\"            \"],[10,2],[12],[8,[32,6],null,[[\"@tags\",\"@categoryId\"],[[30,0,[\"tags\"]],[30,0,[\"soleCategoryId\"]]]],null],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"activeComponent\"]],[[[1,\"            \"],[46,[30,0,[\"activeComponent\"]],null,[[\"onRegisterAction\"],[[30,0,[\"registerCustomAction\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"isCloseAction\"]],[[[1,\"            \"],[10,0],[14,0,\"bulk-close-note-section\"],[12],[1,\"\\n              \"],[10,\"label\"],[12],[1,\"\\n                \"],[1,[28,[32,2],[\"topic_bulk_actions.close_topics.note\"],null]],[1,\" \"],[10,1],[14,0,\"label-optional\"],[12],[1,[28,[32,2],[\"topic_bulk_actions.close_topics.optional\"],null]],[13],[1,\"\\n              \"],[13],[1,\"\\n\\n              \"],[11,\"textarea\"],[24,1,\"bulk-close-note\"],[4,[32,7],[\"input\",[30,0,[\"updateCloseNote\"]]],null],[4,[32,8],null,null],[12],[1,[30,0,[\"closeNote\"]]],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"]],[]]]]],[1,\"\\n      \"]],[]],[[[1,\"\\n\"],[41,[30,1,[\"allowSilent\"]],[[[1,\"          \"],[10,0],[14,0,\"topic-bulk-actions-options\"],[12],[1,\"\\n            \"],[10,\"label\"],[14,\"for\",\"topic-bulk-action-options__silent\"],[14,0,\"checkbox-label\"],[12],[1,\"\\n              \"],[8,[32,9],[[24,1,\"topic-bulk-action-options__silent\"]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"isSilent\"]]]],null],[1,[28,[32,2],[\"topics.bulk.silent\"],null]],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n        \"],[8,[32,10],[[24,0,\"btn-transparent d-modal-cancel\"],[24,1,\"bulk-topics-cancel\"]],[[\"@action\",\"@label\"],[[30,2],\"cancel\"]],null],[1,\"\\n        \"],[8,[32,10],[[24,1,\"bulk-topics-confirm\"],[24,0,\"btn-primary\"]],[[\"@action\",\"@disabled\",\"@icon\",\"@label\"],[[30,0,[\"performAction\"]],[30,0,[\"loading\"]],\"check\",\"topics.bulk.confirm\"]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n  \"]],[\"@model\",\"@closeModal\",\"level\"],false,[\"if\",\"each\",\"-track-array\",\"component\"]]",
    "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/modal/bulk-topic-actions.js",
    "scope": () => [DModal, ConditionalLoadingSection, i18n, htmlSafe, CategoryChooser, RadioButton, TagChooser, on, autoFocus, Input, DButton],
    "isStrictMode": true
  }), this))();
}